import { Announcement as AnnouncementType } from 'types/schema';

import { getOverflowScrollStyle, useOverflowScroll } from 'hooks/use-overflow-scroll';

import * as S from './announcement.styled';

interface AnnouncementProps {
  data: AnnouncementType;
}

export const Announcement = ({ data }: AnnouncementProps) => {
  const description = useOverflowScroll(data.description, 'vertical');

  return (
    <S.Container>
      <S.ImageContainer>
        <S.Image src={data.imageUrls[0]} />
      </S.ImageContainer>
      <S.InfoContainer>
        <S.Title>{data.header}</S.Title>
        <S.Description ref={description.containerRef}>
          <S.DescriptionText
            ref={description.textRef}
            $isScrolling={!!description.scroll}
            style={getOverflowScrollStyle(description.scroll)}
          >
            {data.description}
          </S.DescriptionText>
        </S.Description>
      </S.InfoContainer>
    </S.Container>
  );
};
